$(window).on('load', function () {
    setTimeout(function () {
      $('.gpo-container').wrapAll('<dd class="ac-inner">');
      $('.ac-inner').before('<dt class="ac-tit">包装・のしご入用の方はこちら</dt>');
      $('.ac-tit, .ac-inner').wrapAll('<dl class="ac">');

      $('.ac-tit').addClass('open');
      $('.ac-inner').show();
}, 300);

  $('body').addClass('onload');
});
$(document).on('click', '.ac dt', function () {
  $(this).next('dd').slideToggle();
  $('body').addClass('ondd');
  $(this).toggleClass('open');
});
$(document).on('click', '.menu-ac dt', function () {
  $(this).next('dd').slideToggle();
  $('body').addClass('ondd');
  $(this).toggleClass('open');
});
$(function () {
  /*
	$('.ac dt').click(function(){
		$(this).next('dd').slideToggle();
      $("body").addClass("ondd");
		$(this).toggleClass('open');
	});
  */
  // anchor
  $('p.menu-list a[href^="#"], .store-menu a[href^="#"], .go-top a[href^="#"]').click(function () {
    var speed = 800;
    var href = $(this).attr('href');
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top;
    $('body,html').animate({ scrollTop: position }, speed, 'swing');
    $('body').removeClass('menuOpen');
    return false;
  });

  var con = $('section.slideshow-top').height();

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll > con) {
      $('body').addClass('color');
    } else {
      $('body').removeClass('color');
    }
    if (scroll > 150) {
      $('body').addClass('on');
    } else {
      $('body').removeClass('on');
    }
  });

  //BnK 2402
  $(document).on('click', '.huckleberry-subscription-widget-container input[type="radio"]', function (e) {
    if ($(this).val() == 'subscription') {
      $('body').addClass('subscription-checked');
    } else {
      $('body').removeClass('subscription-checked');
    }
  });
  //BnK 2402
});

// 商品詳細 備考用 2024.11.15

$(function () {
  $('.item-note-open').on('click', function () {
    $('.js-modal').fadeIn();
    return false;
  });
  $('.item-note-close').on('click', function () {
    $('.js-modal').fadeOut();
    return false;
  });
});

// LPページ フェードイン用  2024.12.11

$(function () {
  $(window).scroll(function () {
    const wHeight = $(window).height();
    const wScroll = $(window).scrollTop();
    $('.ani-block').each(function () {
      const bPosition = $(this).offset().top;
      if (wScroll > bPosition - wHeight + 200) {
        $(this).addClass('fade-in');
      }
    });
  });
});

/**
 * PCブラウザでカートに追加ボタンが機能しない問題の修正（2024.03.28）
 * 原因：バリエーション切り替え時にdisabled属性が解除されない
 * SlideshowComponentとVariantSelectsコンポーネントのイベントハンドリングの修正
 */
document.addEventListener('DOMContentLoaded', function () {
  /**
   * 修正1: SlideshowComponentのlinkToSlideメソッドのオーバーライド
   * - フォーム送信時のpreventDefault()を無効化
   */
  const overrideSlideshowLinkToSlide = function () {
    if (typeof SlideshowComponent !== 'undefined') {
      const originalLinkToSlide = SlideshowComponent.prototype.linkToSlide;

      SlideshowComponent.prototype.linkToSlide = function (event) {
        console.log('修正済みlinkToSlideが実行されました');

        // フォーム要素のチェック - フォーム送信イベントであれば preventDefault しない
        const isFormSubmit = event.target.closest('form[data-type="add-to-cart-form"]');
        if (!isFormSubmit) {
          event.preventDefault();
        }

        // 元の処理を継続
        const slideElement = this.sliderFirstItemNode;
        if (slideElement) {
          const slideScrollPosition = this.slider.scrollLeft + slideElement.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
          this.slider.scrollTo({
            left: slideScrollPosition,
          });
        }
      };
    }
  };

  /**
   * 修正2: VariantSelectsのtoggleAddButtonメソッドのオーバーライド
   * - 非同期処理を追加してdisabled属性を確実に解除
   */
  const overrideToggleAddButton = function () {
    if (typeof VariantSelects !== 'undefined') {
      const originalToggleAddButton = VariantSelects.prototype.toggleAddButton;

      VariantSelects.prototype.toggleAddButton = function (disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          // タイムアウトを追加して非同期処理にすることで、イベント伝播の問題を回避
          setTimeout(() => {
            console.log('カートボタンのdisabled属性を解除します');
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
          }, 0);
        }

        if (!modifyClass) return;
      };
    }
  };

  /**
   * 修正3: VariantSelectsのupdateVariantInputメソッドのオーバーライド
   * - input[name="id"]のdisabled属性を明示的に解除
   */
  const overrideUpdateVariantInput = function () {
    if (typeof VariantSelects !== 'undefined') {
      const originalUpdateVariantInput = VariantSelects.prototype.updateVariantInput;

      VariantSelects.prototype.updateVariantInput = function () {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);

        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;

          // PCブラウザでの問題を解決するため、disabled属性を明示的に解除
          if (this.currentVariant.available) {
            input.removeAttribute('disabled');
          }

          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      };
    }
  };

  /**
   * 修正4: VariantSelectsのupdateMediaメソッドのオーバーライド
   * - mediaGalleryの存在チェックとエラーハンドリングを追加
   */
  const overrideUpdateMedia = function () {
    if (typeof VariantSelects !== 'undefined') {
      const originalUpdateMedia = VariantSelects.prototype.updateMedia;

      VariantSelects.prototype.updateMedia = function () {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (mediaGalleries.length > 0) {
          mediaGalleries.forEach((mediaGallery) => {
            // setActiveMediaメソッドが存在する場合のみ呼び出し
            if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
              try {
                mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
              } catch (error) {
                console.warn('メディアギャラリーの更新中にエラーが発生しました:', error);
              }
            }
          });
        }

        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;

        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        if (newMediaModal) {
          modalContent.prepend(newMediaModal);
        }
      };
    }
  };

  /**
   * 修正5: SlideshowComponentのupdateメソッドのオーバーライド
   * - ボタン要素の存在チェックと配列範囲外アクセスの防止
   */
  const overrideSlideshowUpdate = function () {
    if (typeof SlideshowComponent !== 'undefined') {
      const originalUpdate = SlideshowComponent.prototype.update;

      SlideshowComponent.prototype.update = function () {
        // 元のスーパークラスのupdateメソッドを呼び出し
        SliderComponent.prototype.update.call(this);

        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

        // prevButtonが存在する場合のみdisabled属性を削除
        if (this.prevButton) {
          this.prevButton.removeAttribute('disabled');
        }

        // スライダーコントロールボタンが存在しない場合は処理を中止
        if (!this.sliderControlButtons.length) return;

        // すべてのコントロールボタンからアクティブ状態を削除
        this.sliderControlButtons.forEach((link) => {
          link.classList.remove('slider-counter__link--active');
          link.removeAttribute('aria-current');
        });

        // 現在のページに対応するボタンが存在する場合のみアクティブ状態を設定
        if (this.currentPage > 0 && this.currentPage <= this.sliderControlButtons.length) {
          const currentButton = this.sliderControlButtons[this.currentPage - 1];
          if (currentButton) {
            currentButton.classList.add('slider-counter__link--active');
            currentButton.setAttribute('aria-current', true);
          }
        }
      };
    }
  };

  // すべての修正を適用
  try {
    overrideSlideshowLinkToSlide();
    overrideToggleAddButton();
    overrideUpdateVariantInput();
    overrideUpdateMedia();
    overrideSlideshowUpdate();
    console.log('PCブラウザ対応の修正が正常に適用されました');
  } catch (error) {
    console.error('PCブラウザ対応の修正適用中にエラーが発生しました:', error);
  }
});